import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { ContentLayout13 } from '@components/content/components/content-layout-13/model';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-content-layout-13',
  imports: [TitleComponent],
  templateUrl: './content-layout-13.component.html',
  styleUrl: './content-layout-13.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout13Component implements OnInit {
  readonly data = input.required<ContentLayout13>();
  titleG = signal<Title>(null!);
  titleD = signal<Title>(null!);

  ngOnInit(): void {
    this.titleG.set({
      level: 'H2',
      size: {
        mobile: 'H4',
        desktop: 'H4',
      },
      font: 'IVY_MODE',
      color: 'WHITE',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().titleG,
    });
    this.titleD.set({
      level: 'H2',
      size: {
        mobile: 'H4',
        desktop: 'H4',
      },
      font: 'IVY_MODE',
      color: 'WHITE',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().titleD,
    });
  }
}
